import { DialogConfirm } from 'app/components/elements/DialogConfirm';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FormSendMailSchema } from 'utils/validate';
import { ButtonCustom } from '../../../components/elements/ButtonCustom';
import { AutocompleteCustom } from '../../../components/elements/AutocompleteCustom';

export type FormSendMail = {
  email: string[];
};

type ModalSendMailProps = {
  isOpen: boolean;
  onCloseModal: () => void;
  onSubmit: (value: FormSendMail) => void;
  options: { label: string; value: string }[];
  loading?: boolean;
};

export const ModalSendMail = ({
  isOpen,
  onCloseModal,
  onSubmit,
  options,
  loading
}: ModalSendMailProps) => {
  const [optionOther, setOptionOther] = useState<{ label: string; value: string }[]>([]);
  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors }
  } = useForm<FormSendMail>({
    resolver: yupResolver(FormSendMailSchema)
  });

  useEffect(() => {
    if (!isOpen) {
      setValue('email', []);
      setOptionOther([]);
    }
  }, [isOpen, setValue]);
  // Helper để convert từ string[] sang option[]
  const getOptionByValue = (arr: string[]) =>
    [...optionOther, ...options].filter((opt) => arr?.includes(opt.value));

  return (
    <DialogConfirm
      maxWidth={700}
      textTitle={'Forward Report'}
      isOpen={isOpen}
      onClose={onCloseModal}>
      <Stack width={'100%'} gap={2.5}>
        <Controller
          name="email"
          control={control}
          render={({ field: { value } }) => (
            <AutocompleteCustom
              setOptionOther={setOptionOther}
              options={options}
              optionOther={optionOther}
              value={getOptionByValue(value || [])}
              onChange={(selectedOptions) => {
                setValue(
                  'email',
                  selectedOptions.map((opt) => opt.value)
                );
              }}
              label="Email"
              placeholder="Send to..."
              loading={loading}
              error={!!errors.email}
              helperText={errors.email?.message as string}
            />
          )}
        />
        <ButtonCustom onClick={handleSubmit(onSubmit)} label={'Send'} />
      </Stack>
    </DialogConfirm>
  );
};
